import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import CTASection from "@/components/sections/CTASection";
import SiteFooter from "@/components/SiteFooter";
import { SERVICE_LIST } from "@/data/services";

export default function Services() {
  return (
    <PageShell>
      <PageHeader
        overline="What we offer"
        title={<>Services built for brands<br />that demand precision.</>}
        subtitle="Ten core practices, one accountable team — designed to make every touchpoint of your brand look and feel premium."
        breadcrumbs={[{ to: "/", label: "Home" }, { label: "Services" }]}
      />

      <section data-testid="services-grid-section" className="py-20 md:py-28">
        <div className="pz-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {SERVICE_LIST.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`service-card-${s.slug}`}
                className="group rounded-2xl overflow-hidden bg-white dark:bg-white/[0.03] border border-slate-200 dark:border-white/10 hover:-translate-y-1.5 hover:shadow-2xl hover:border-[#F59E0B]/40 transition-all flex flex-col"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                  <div className="absolute top-5 left-5 w-12 h-12 rounded-xl bg-white text-[#0F172A] grid place-items-center shadow-lg">
                    <Icon className="w-6 h-6" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="p-7 flex-1 flex flex-col">
                  <h3 className="font-display text-2xl font-semibold text-[#0F172A] dark:text-white">{s.title}</h3>
                  <p className="mt-3 text-slate-600 dark:text-white/65 text-sm leading-relaxed flex-1">{s.short}</p>
                  <Link
                    to="/contact"
                    data-testid={`service-learn-${s.slug}`}
                    className="mt-6 inline-flex items-center gap-1.5 self-start text-sm font-medium text-[#2563EB] dark:text-[#F59E0B]"
                  >
                    Learn More <ArrowUpRight className="w-4 h-4" />
                  </Link>
                </div>
              </motion.article>
            );
          })}
        </div>
      </section>

      <CTASection />
      <SiteFooter />
    </PageShell>
  );
}
